let MAX_FILE_SIZE = 1024 * 1024 * 50 // 50MB
let ALLOWED_FILE_TYPES = ['image/*']

export function restrictions() {
  return {
    maxFileSize: MAX_FILE_SIZE,
    allowedFileTypes: ALLOWED_FILE_TYPES,
  }
}
